var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSearchNew = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.678,
    height: 11.677,
    viewBox: "0 0 11.678 11.677",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10.363,10.363a.73.73,0,0,1,1.033,0l2.81,2.81a.73.73,0,0,1-1.032,1.033l-2.81-2.81a.73.73,0,0,1,0-1.033Z",
    transform: "translate(-2.742 -2.742)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4.744,8.758A4.014,4.014,0,1,0,.73,4.744,4.014,4.014,0,0,0,4.744,8.758ZM9.488,4.744A4.744,4.744,0,1,1,4.744,0,4.744,4.744,0,0,1,9.488,4.744Z",
    transform: "translate(0 0)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSearchNew);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMS42NzgiIGhlaWdodD0iMTEuNjc3IiB2aWV3Qm94PSIwIDAgMTEuNjc4IDExLjY3NyI+PGRlZnM+PHN0eWxlPi5he2ZpbGwtcnVsZTpldmVub2RkO308L3N0eWxlPjwvZGVmcz48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIDApIj48cGF0aCBjbGFzcz0iYSIgZD0iTTEwLjM2MywxMC4zNjNhLjczLjczLDAsMCwxLDEuMDMzLDBsMi44MSwyLjgxYS43My43MywwLDAsMS0xLjAzMiwxLjAzM2wtMi44MS0yLjgxYS43My43MywwLDAsMSwwLTEuMDMzWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTIuNzQyIC0yLjc0MikiLz48cGF0aCBjbGFzcz0iYSIgZD0iTTQuNzQ0LDguNzU4QTQuMDE0LDQuMDE0LDAsMSwwLC43Myw0Ljc0NCw0LjAxNCw0LjAxNCwwLDAsMCw0Ljc0NCw4Ljc1OFpNOS40ODgsNC43NDRBNC43NDQsNC43NDQsMCwxLDEsNC43NDQsMCw0Ljc0NCw0Ljc0NCwwLDAsMSw5LjQ4OCw0Ljc0NFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMCkiLz48L2c+PC9zdmc+";